import { IconButton, Tooltip } from '@mui/material'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import { useMethodology } from './MethodologyContext'
import { getClimateHazardMethodology } from '../climateAnalytics/common/hazardConfig'

type MethodologyIconButtonProps = {
  hazardCode: string
  /** Optional section id to scroll to in the drawer (matches a slug in HAZARD_META). */
  anchor?: string
  /** Optional override for tooltip text and aria-label. */
  label?: string
  size?: 'small' | 'medium'
}

/**
 * Discreet "open methodology" trigger. Placed next to hazard titles and inside
 * `PropertyClimateHazardsCard` rows. Visually matches
 * `HazardScenarioPreferenceControl` so the dashboard chrome remains consistent.
 */
export default function MethodologyIconButton({
  hazardCode,
  anchor,
  label,
  size = 'small',
}: MethodologyIconButtonProps) {
  const { openMethodology } = useMethodology()
  const methodology = getClimateHazardMethodology(hazardCode)
  if (!methodology) return null

  const tooltip = label ?? `View ${methodology.label} methodology`

  return (
    <Tooltip title={tooltip}>
      <IconButton
        size={size}
        aria-label={tooltip}
        sx={{
          width: 28,
          height: 28,
          color: 'text.secondary',
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': { color: 'primary.main', backgroundColor: 'action.hover' },
        }}
        onMouseDown={event => {
          // Prevent parent click handlers (e.g. hazard picker, row link) from firing.
          event.preventDefault()
          event.stopPropagation()
        }}
        onClick={event => {
          event.preventDefault()
          event.stopPropagation()
          openMethodology({ hazardCode, anchor })
        }}>
        <MenuBookOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  )
}
